export default  {
  orange : "#E35226",
  orange_darker:"#d83c0c",
  blueblack:"#092C46",
  blueblack_darker: "#011D33",
  light_blue:"#66ACE0"
}